import React, { useState, useEffect } from 'react';
import { Card, CardContent, Typography, Button, withStyles, Dialog, DialogActions, DialogContent, DialogTitle, Select, MenuItem, FormControl, InputLabel, Checkbox, FormControlLabel, Chip, TextField, IconButton } from '@material-ui/core';
import { FaArrowLeft, FaArrowRight, FaAngleDoubleLeft, FaAngleDoubleRight } from 'react-icons/fa';
import axios from 'axios';
import { translateText } from '../../utils/translate';
import cidadesData from '../Utils/cidades.json';
import { isVisitorCookiesAllowed } from '../Utils/CookieConsent';
import HeaderMenu from '../Utils/Header';
import Footer from '../Utils/Footer';
import RouteTracker from '../Utils/RouteTracker';

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: 0,
    backgroundColor: '#fff',
    color: '#333',
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
  },
  filtersWrapper: {
    display: 'flex',
    justifyContent: 'flex-end', // Top right
    alignItems: 'flex-start',
    marginBottom: theme.spacing.unit * 3,
    marginTop: theme.spacing.unit * 1,
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing.unit * 1,
    },
  },
  filters: {
    display: 'flex',
    justifyContent: 'flex-end', // Top right
    alignItems: 'center',
    gap: theme.spacing.unit * 2.5,
    flexWrap: 'wrap',
    [theme.breakpoints.down('sm')]: {
      flexDirection: 'column',
      alignItems: 'stretch',
      gap: theme.spacing.unit * 1.5,
    },
  },
  filterGroup: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center', // Center content horizontally (including checkboxes)
    marginRight: theme.spacing.unit * 1.5,
    marginBottom: 0, // Remove extra bottom margin for alignment
    minWidth: 140,
    [theme.breakpoints.down('sm')]: {
      marginRight: 0,
      minWidth: '100%',
    },
  },
  // Add a new style for the checkbox group
  checkboxGroup: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing.unit * 2,
    alignItems: 'center',
    justifyContent: 'center',
    marginBottom: 0,
    minHeight: 56,
    marginTop: 20, // Add top margin to align with dropdowns
  },
  checkboxRow: {
    display: 'flex',
    flexDirection: 'row',
    gap: theme.spacing.unit * 2,
    alignItems: 'center',
    justifyContent: 'center',
  },
  grid: {
    marginTop: theme.spacing.unit * 2,
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fit, minmax(480px, 1fr))',
    gap: theme.spacing.unit * 3,
    [theme.breakpoints.down('xl')]: {
      gridTemplateColumns: 'repeat(2, minmax(420px, 1fr))',
      gap: theme.spacing.unit * 2.5,
    },
    [theme.breakpoints.down('lg')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing.unit * 2,
    },
    [theme.breakpoints.down('md')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing.unit * 1.5,
    },
    [theme.breakpoints.down('sm')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing.unit,
    },
    [theme.breakpoints.down('xs')]: {
      gridTemplateColumns: '1fr',
      gap: theme.spacing.unit * 0.5,
    },
  },
  card: {
    display: 'flex',
    flexDirection: 'row',
    minWidth: 0,
    minHeight: 260,
    boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
    borderRadius: theme.spacing.unit,
    overflow: 'hidden',
    position: 'relative',
    zIndex: 1,
    cursor: 'pointer',
    backgroundColor: '#fff',
    color: '#333',
    marginBottom: '10px',
    marginRight: '10px',
  },
  media: {
    width: '58%',
    minWidth: 220,
    height: '100%',
    objectFit: 'cover',
  },
  content: {
    flex: '1 0 auto',
    padding: theme.spacing.unit * 2,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    width: '42%',
    minWidth: 180,
  },
  userInfo: {
    marginTop: theme.spacing.unit * 2,
    width: '100%',
    padding: theme.spacing.unit * 2,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  userPhoto: {
    width: 100,
    height: 100,
    borderRadius: '50%',
    objectFit: 'cover',
    marginBottom: theme.spacing.unit,
  },
  noData: {
    textAlign: 'center',
    color: '#999',
    marginTop: theme.spacing.unit * 4,
  },
  dialogContent: {
    padding: theme.spacing.unit * 2,
  },
  dialogTitle: {
    padding: theme.spacing.unit * 2,
  },
  imageList: {
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: theme.spacing.unit,
    marginTop: theme.spacing.unit * 2,
  },
  imageItem: {
    cursor: 'pointer',
    width: 100,
    height: 100,
    objectFit: 'cover',
  },
  selectedImage: {
    width: '100%',
    height: 'auto',
    marginBottom: theme.spacing.unit * 2,
  },
  banner: {
    position: 'absolute',
    top: '70px', // Move the banner down
    left: '0px', // Move the banner to the left
    width: '90px',
    height: '25px',
    backgroundColor: 'rgba(255, 255, 255, 0.8)',
    color: '#fff',
    textAlign: 'center',
    lineHeight: '30px',
    transform: 'rotate(-45deg)', // Flip the rotation for left side
    transformOrigin: 'top left', // Anchor to top left
    zIndex: 2,
  },
  premiumBanner: {
    backgroundColor: '#0000FF', // Blue color for Premium
  },
  opportunityBanner: {
    backgroundColor: '#FF0000', // Red color for Opportunity
    top: '90px', // Align with the premium banner
    left: '20px', // Adjust position to be side by side on the left
  },
  pagination: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: theme.spacing.unit * 4,
    marginBottom: theme.spacing.unit * 2,
    gap: theme.spacing.unit * 2,
    [theme.breakpoints.down('lg')]: {
      gap: theme.spacing.unit * 1.5,
    },
    [theme.breakpoints.down('md')]: {
      gap: theme.spacing.unit,
    },
    [theme.breakpoints.down('sm')]: {
      gap: theme.spacing.unit * 0.8,
    },
    [theme.breakpoints.down('xs')]: {
      gap: theme.spacing.unit * 0.5,
    },
  },
});

const translations = {
  en: {
    loading: "Loading objects...",
    noData: "No objects available at the moment.",
    detailsTitle: "Objects Details",
    location: "Location",
    price: "Price",
    description: "Description",
    images: "Images",
    agentInfo: "Agent Information",
    name: "Name",
    email: "Email",
    contact: "Contact",
    close: "Close",
    district: "District",
    premium: "Premium",
    opportunity: "Opportunity",
    keywords: "Keywords",
    noImages: "No images available.",
  },
  pt: {
    loading: "Carregando objeto...",
    noData: "Não existem objeto disponíveis no momento.",
    detailsTitle: "Detalhes do Objeto",
    location: "Localização",
    price: "Preço",
    description: "Descrição",
    images: "Imagens",
    agentInfo: "Informações do Agente",
    name: "Nome",
    email: "Email",
    contact: "Contato",
    close: "Fechar",
    district: "Distrito",
    premium: "Premium",
    opportunity: "Oportunidade",
    keywords: "Palavras-chave",
    noImages: "Não há imagens disponíveis.",
  },
  fr: {
    loading: "Chargement des objets...",
    noData: "Aucun objets disponible pour le moment.",
    detailsTitle: "Détails de l'Objets",
    location: "Emplacement",
    price: "Prix",
    description: "Description",
    images: "Images",
    agentInfo: "Informations sur l'Agent",
    name: "Nom",
    email: "Email",
    contact: "Contact",
    close: "Fermer",
    district: "District",
    premium: "Premium",
    opportunity: "Opportunité",
    keywords: "Mots-clés",
    noImages: "Aucune image disponible.",
  },
};

// Utility to ensure images_path is always an array
const parseImagesPath = (images_path) => {
  if (Array.isArray(images_path)) return images_path;
  if (typeof images_path === "string") {
    try {
      const arr = JSON.parse(images_path);
      return Array.isArray(arr) ? arr : [];
    } catch {
      return [];
    }
  }
  return [];
};

const MoveisPage = ({ classes }) => {
  const [moveis, setMoveis] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedMovel, setSelectedMovel] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [enlargedImage, setEnlargedImage] = useState(null);
  const [district, setDistrict] = useState('');
  const [city, setCity] = useState('');
  const [cities, setCities] = useState([]);
  const [premium, setPremium] = useState(false);
  const [opportunity, setOpportunity] = useState(false);
  const [keywords, setKeywords] = useState('');
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 20;
  const [language, setLanguage] = useState(localStorage.getItem("language") || "pt");
  const t = translations[language];
  const getApiUrl = () => "/api";
  const API_URL = getApiUrl();
  const districts = Object.keys(cidadesData);

  useEffect(() => {
    if (district) {
      setCities(cidadesData[district] || []);
    } else {
      setCities([]);
    }
    setCity('');
  }, [district]);

  useEffect(() => {
    fetchMoveis();
  }, []);

  useEffect(() => {
    const handleLanguageChange = () => {
      const lang = localStorage.getItem("language") || "pt";
      setLanguage(lang);
      if (isVisitorCookiesAllowed()) {
        localStorage.setItem("language", lang);
      }
    };
    window.addEventListener("languageChange", handleLanguageChange);
    return () => window.removeEventListener("languageChange", handleLanguageChange);
  }, []);

  // Clear filters on unmount (leaving the page)
  useEffect(() => {
    return () => {
      setDistrict('');
      setCity('');
      setCities([]);
      setPremium(false);
      setOpportunity(false);
      setKeywords('');
    };
  }, []);

  const fetchMoveis = async () => {
    try {
      // Use only active endpoint for customer view
      const response = await axios.get(`${API_URL}/moveis`);
      const translatedMoveis = await Promise.all(response.data.map(async (movel) => {
        if (language !== "pt") {
          const translatedTitle = await translateText(movel.title, language);
          return { ...movel, title: translatedTitle };
        }
        return movel;
      }));
      setMoveis(translatedMoveis);
      setIsLoading(false);
    } catch (error) {
      console.error('Error fetching outros:', error);
      setError('Erro ao carregar os outros.');
      setIsLoading(false);
    }
  };

  // Helper to get current image list and index
  const getImageList = () => {
    if (!selectedMovel) return [];
    return parseImagesPath(selectedMovel.images_path);
  };
  const getCurrentImageIndex = () => {
    const images = getImageList();
    return images.indexOf(selectedImage);
  };
  const handlePrevImage = () => {
    const images = getImageList();
    const idx = getCurrentImageIndex();
    if (idx > 0) setSelectedImage(images[idx - 1]);
  };
  const handleNextImage = () => {
    const images = getImageList();
    const idx = getCurrentImageIndex();
    if (idx < images.length - 1) setSelectedImage(images[idx + 1]);
  };

  // Ensure selectedImage is set after selectedMovel changes
  useEffect(() => {
    const images = getImageList();
    if (images.length > 0) {
      setSelectedImage(images[0]);
    }
  }, [selectedMovel]);

  // Update handleViewDetails to parse images_path and only use backend variable names
  const handleViewDetails = async (movel) => {
    const translatedTitle = await translateText(movel.title, language);
    const translatedDescription = await translateText(movel.description, language);
    const images_path = parseImagesPath(movel.images_path);
    setSelectedMovel({
      ...movel,
      title: translatedTitle,
      description: translatedDescription,
      images_path,
    });
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setSelectedMovel(null);
    setSelectedImage(null);
  };

  // Update applyFilters to use the above state variables
  const applyFilters = (moveis) => {
    return moveis.filter((movel) => (
      (district === '' || movel.district === district) &&
      (city === '' || movel.city === city) &&
      (!premium || movel.premium) &&
      (!opportunity || movel.opportunity) &&
      (keywords === '' || movel.title.toLowerCase().includes(keywords.toLowerCase()))
    ));
  };

  const filteredMoveis = applyFilters(moveis);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  const totalPages = Math.ceil(filteredMoveis.length / itemsPerPage);
  const paginatedMoveis = filteredMoveis.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);

  const renderPageButtons = () => {
    const pageButtons = [];
    const startPage = Math.max(1, currentPage - 2);
    const endPage = Math.min(totalPages, currentPage + 2);

    for (let i = startPage; i <= endPage; i++) {
      pageButtons.push(
        <Button
          key={i}
          className={classes.pageButton}
          onClick={() => handlePageChange(i)}
          variant={currentPage === i ? 'contained' : 'outlined'}
          color="primary"
        >
          {i}
        </Button>
      );
    }

    return pageButtons;
  };

  // Helper for enlarged image navigation
  const getEnlargedImageIndex = () => {
    if (!selectedMovel || !Array.isArray(selectedMovel.images_path) || !enlargedImage) return -1;
    return selectedMovel.images_path.indexOf(enlargedImage);
  };
  const handlePrevEnlargedImage = () => {
    const idx = getEnlargedImageIndex();
    if (idx > 0) setEnlargedImage(selectedMovel.images_path[idx - 1]);
  };
  const handleNextEnlargedImage = () => {
    const idx = getEnlargedImageIndex();
    if (idx < selectedMovel.images_path.length - 1) setEnlargedImage(selectedMovel.images_path[idx + 1]);
  };

  return (
    <>
      <HeaderMenu />
      <RouteTracker />
      <div className={classes.root}>
        {/* All filters in the top right */}
        <div className={classes.filtersWrapper}>
          <div className={classes.filters}>
            {/* Uncomment to enable keyword search */}
            {/* 
            <div className={classes.filterGroup}>
              <TextField
                name="keywords"
                label={t.keywords}
                value={filters.keywords}
                onChange={handleFilterChange}
                className={classes.filterItem}
                fullWidth
              />
            </div>
            */}
            {/* District filter */}
            <div className={classes.filterGroup}>
              <FormControl className={classes.filterItem} fullWidth>
                <InputLabel>{t.district}</InputLabel>
                <Select
                  name="district"
                  value={district}
                  onChange={e => setDistrict(e.target.value)}
                >
                  <MenuItem value=""><em>Todos</em></MenuItem>
                  {districts.map((d, idx) => (
                    <MenuItem key={idx} value={d}>{d}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {/* City filter (moved up) */}
            <div className={classes.filterGroup}>
              <FormControl className={classes.filterItem} fullWidth>
                <InputLabel>Cidade</InputLabel>
                <Select
                  name="city"
                  value={city}
                  onChange={e => setCity(e.target.value)}
                  disabled={!district}
                >
                  <MenuItem value=""><em>Todos</em></MenuItem>
                  {cities.map((c, idx) => (
                    <MenuItem key={idx} value={c}>{c}</MenuItem>
                  ))}
                </Select>
              </FormControl>
            </div>
            {/* Checkboxes */}
            <div className={classes.filterGroup + ' ' + classes.checkboxGroup}>
              <FormControlLabel
                control={
                  <Checkbox
                    name="premium"
                    checked={premium}
                    onChange={e => setPremium(e.target.checked)}
                    style={{ color: '#0000FF' }}
                  />
                }
                label={t.premium}
                className={classes.filterItem}
              />
              <FormControlLabel
                control={
                  <Checkbox
                    name="opportunity"
                    checked={opportunity}
                    onChange={e => setOpportunity(e.target.checked)}
                    style={{ color: '#FF0000' }}
                  />
                }
                label={t.opportunity}
                className={classes.filterItem}
              />
            </div>
          </div>
        </div>
        {/* Cards */}
        {isLoading ? (
          <Typography variant="h6" className={classes.noData}>
            {t.loading}
          </Typography>
        ) : error ? (
          <Typography variant="h6" className={classes.noData}>
            {error}
          </Typography>
        ) : paginatedMoveis.length > 0 ? (
          <div className={classes.grid}>
            {paginatedMoveis.map((movel) => (
              <Card key={movel.id} className={classes.card} onClick={() => handleViewDetails(movel)}>
                {movel.premium && (
                  <Chip label={t.premium} className={`${classes.banner} ${classes.premiumBanner}`} />
                )}
                {movel.opportunity && (
                  <Chip label={t.opportunity} className={`${classes.banner} ${classes.opportunityBanner}`} />
                )}
                <div className={classes.media}>
                  {movel.prompt_image ? (
                    <img
                      src={`/Photos/Moveis/${movel.id}/${movel.prompt_image}`}
                      alt={movel.title}
                      style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      onError={e => { e.target.onerror = null; e.target.style.display = 'none'; e.target.parentNode.querySelector('.no-image-msg').style.display = 'flex'; }}
                    />
                  ) : null}
                  <div
                    className="no-image-msg"
                    style={{
                      display: movel.prompt_image ? 'none' : 'flex',
                      width: '100%',
                      height: '100%',
                      alignItems: 'center',
                      justifyContent: 'center',
                      background: '#f0f0f0',
                      color: '#888',
                      fontWeight: 'bold',
                      position: movel.prompt_image ? 'absolute' : 'static',
                      top: 0,
                      left: 0,
                    }}
                  >
                    {t.noImages}
                  </div>
                </div>
                <CardContent className={classes.content}>
                  <div>
                    <Typography variant="h5" component="h2" style={{ fontWeight: 'bold' }}>
                      {movel.title}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {t.location}: {movel.district}{movel.city ? `, ${movel.city}` : ''}
                    </Typography>
                    <Typography variant="body2" color="textSecondary">
                      {t.price}: €{movel.price.toLocaleString()}
                    </Typography>
                  </div>
                </CardContent>
              </Card>
            ))}
          </div>
        ) : (
          <Typography variant="h6" className={classes.noData}>
            {t.noData}
          </Typography>
        )}
        {/* Pagination Controls */}
        <div className={classes.pagination}>
          <IconButton
            className={classes.pageButton}
            onClick={() => handlePageChange(1)}
            disabled={currentPage === 1}
          >
            <FaAngleDoubleLeft />
          </IconButton>
          <IconButton
            className={classes.pageButton}
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
          >
            <FaArrowLeft />
          </IconButton>
          {renderPageButtons()}
          <IconButton
            className={classes.pageButton}
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
          >
            <FaArrowRight />
          </IconButton>
          <IconButton
            className={classes.pageButton}
            onClick={() => handlePageChange(totalPages)}
            disabled={currentPage === totalPages}
          >
            <FaAngleDoubleRight />
          </IconButton>
        </div>
        {/* Modal Dialog for Showing Movel Details */}
        <Dialog
          open={openDialog}
          onClose={handleCloseDialog}
          maxWidth="md"
          fullWidth
        >
          <DialogTitle className={classes.dialogTitle}>
            {t.detailsTitle}
          </DialogTitle>
          <DialogContent className={classes.dialogContent}>
            {selectedMovel ? (
              <div>
                {/* --- Object Details Section --- */}
                <div style={{
                  borderBottom: '1px solid #eee',
                  marginBottom: 16,
                  paddingBottom: 8
                }}>
                  <Typography variant="h5" style={{ fontWeight: 'bold', marginBottom: 8 }}>
                    {selectedMovel.title}
                  </Typography>
                  <div style={{ display: 'flex', flexWrap: 'wrap', gap: 16 }}>
                    {/* Left: Main info */}
                    <div style={{ minWidth: 200, flex: '0 0 220px' }}>
                      <Typography variant="body1"><b>{t.location}:</b> {selectedMovel.district}{selectedMovel.city ? `, ${selectedMovel.city}` : ''}</Typography>
                      <Typography variant="body1"><b>{t.price}:</b> €{selectedMovel.price.toLocaleString()}</Typography>
                    </div>
                    {/* Vertical divider */}
                    <div style={{
                      width: 1,
                      background: '#bbb',
                      margin: '0 16px',
                      minHeight: 60,
                      alignSelf: 'stretch'
                    }} />
                    {/* Right: Description */}
                    <div style={{ flex: 1, minWidth: 250 }}>
                      <Typography variant="body1" style={{ marginBottom: 4 }}>
                        <b>{t.description}:</b>
                      </Typography>
                      <Typography variant="body2" style={{ whiteSpace: 'pre-line' }}>
                        {selectedMovel.description}
                      </Typography>
                    </div>
                  </div>
                </div>
                {/* --- Images Carousel Section --- */}
                <div style={{
                  borderBottom: '1px solid #eee',
                  marginBottom: 16,
                  paddingBottom: 8
                }}>
                  <Typography variant="h6" style={{ marginBottom: 8 }}>{t.images}:</Typography>
                  {Array.isArray(selectedMovel.images_path) && selectedMovel.images_path.length > 0 ? (
                    <div>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginBottom: 8 }}>
                        <IconButton onClick={handlePrevImage} disabled={getCurrentImageIndex() <= 0}>
                          <FaArrowLeft />
                        </IconButton>
                        {selectedImage && (
                          <img
                            src={`/Photos/Moveis/${selectedMovel.id}/${selectedImage}`}
                            alt={selectedMovel.title}
                            className={classes.selectedImage}
                            style={{maxHeight: 1000, borderRadius: 8, boxShadow: '0 2px 8px #0001', cursor: 'pointer' }}
                            onClick={() => setEnlargedImage(selectedImage)}
                          />
                        )}
                        <IconButton onClick={handleNextImage} disabled={getCurrentImageIndex() >= selectedMovel.images_path.length - 1}>
                          <FaArrowRight />
                        </IconButton>
                      </div>
                      <div className={classes.imageList} style={{ justifyContent: 'center' }}>
                        {selectedMovel.images_path.map((image, index) => (
                          <img
                            key={index}
                            src={`/Photos/Moveis/${selectedMovel.id}/${image}`}
                            alt={`${selectedMovel.title} ${index + 1}`}
                            className={classes.imageItem}
                            onClick={() => setEnlargedImage(image)}
                            style={{
                              border: selectedImage === image ? '2px solid #1976d2' : '1px solid #eee',
                              borderRadius: 4,
                              boxShadow: selectedImage === image ? '0 2px 8px #1976d233' : 'none',
                              cursor: 'pointer'
                            }}
                          />
                        ))}
                      </div>
                    </div>
                  ) : (
                    <Typography variant="body2" color="textSecondary">{t.noImages}</Typography>
                  )}
                </div>
                {/* --- User/Agent Information Section --- */}
                <div>
                  <Typography variant="h6" style={{ marginBottom: 8 }}>{t.agentInfo}:</Typography>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                    {selectedMovel.user_photo && (
                      <img
                        src={`/Photos/Users/${selectedMovel.user_photo}`}
                        alt={selectedMovel.user_name}
                        className={classes.userPhoto}
                        style={{ border: '2px solid #1976d2', marginRight: 16 }}
                      />
                    )}
                    <div>
                      <Typography variant="body1"><b>{t.name}:</b> {selectedMovel.user_name}</Typography>
                      <Typography variant="body1"><b>{t.email}:</b> {selectedMovel.user_email}</Typography>
                      <Typography variant="body1"><b>{t.contact}:</b> {selectedMovel.user_contact}</Typography>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <Typography variant="h6">{t.noData}</Typography>
            )}
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseDialog} color="primary">
              {t.close}
            </Button>
          </DialogActions>
        </Dialog>
        {/* Enlarged Image Modal */}
        <Dialog
          open={!!enlargedImage}
          onClose={() => setEnlargedImage(null)}
          maxWidth="lg"
        >
          <DialogContent style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', background: '#222', position: 'relative', minHeight: 300 }}>
            {selectedMovel && enlargedImage && (
              <>
                <IconButton
                  onClick={handlePrevEnlargedImage}
                  disabled={getEnlargedImageIndex() <= 0}
                  style={{ position: 'absolute', left: 10, top: '50%', transform: 'translateY(-50%)', color: '#fff', background: 'rgba(0,0,0,0.3)' }}
                >
                  <FaArrowLeft />
                </IconButton>
                <img
                  src={`/Photos/Moveis/${selectedMovel.id}/${enlargedImage}`}
                  alt="Enlarged"
                  style={{ maxWidth: '90vw', maxHeight: '80vh', borderRadius: 8, background: '#fff', cursor: 'pointer' }}
                  onClick={() => setEnlargedImage(null)}
                />
                <IconButton
                  onClick={handleNextEnlargedImage}
                  disabled={getEnlargedImageIndex() >= selectedMovel.images_path.length - 1}
                  style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', color: '#fff', background: 'rgba(0,0,0,0.3)' }}
                >
                  <FaArrowRight />
                </IconButton>
              </>
            )}
          </DialogContent>
        </Dialog>
      </div>
      <Footer />
    </>
  );
};

export default withStyles(styles)(MoveisPage);
